import CardCredentialOtpScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialOtpScreen/CardCredentialOtpScreen';
import React from 'react';

export default function CardCredentialOtpPage() {
  return <CardCredentialOtpScreen />;
}
